import { SvgIcon } from "@mui/material"

import { ReactComponent as MoneyIconSvg } from "./MoneyIcon.svg"

export const MoneyIcon = (props) => {
    return (
        <SvgIcon component={MoneyIconSvg} {...props} inheritViewBox />
    )
}